var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asistencias-list"},_vm._l((_vm.asistencias),function(asistencia){return _c('asistencia-card',{key:("asistencia#" + (asistencia.id)),attrs:{"asistencia":asistencia}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }